import React from 'react';
import { TransactionTableInterface } from '../utils';
import DataGrid from '../../DataGrid/DataGrid';
import { PaginationMode } from '../../DataGrid/types';
import {
    DidUsageTableRowInterface,
    generateColumns,
    useStyles,
} from './DidUsage.utils';
import { didUsageEntityTransformer } from '../../../utils/transformers';
import { useTranslation } from 'react-i18next';

const DidUsage: React.VFC<TransactionTableInterface> = ({
    currency,
    data,
    onPageChange,
    onPageSizeChange,
    initialPageSize,
    loading,
    rowCount,
    userDateTimeFormat,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const columns = generateColumns(t, currency, userDateTimeFormat);

    const items: DidUsageTableRowInterface[] = data.map(
        didUsageEntityTransformer,
    );

    return (
        <DataGrid<DidUsageTableRowInterface>
            data={items}
            dataQa={'did-usage-table'}
            loading={loading}
            columns={columns}
            rowCount={rowCount}
            paginationMode={PaginationMode.Server}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            initialPageSize={initialPageSize}
            classes={{
                header: classes.header,
                tableContainer: classes.tableContent,
            }}
        />
    );
};

export default DidUsage;
